var _ = require('underscore');

var utils = require('./utils');


// Matches AVAILABLE_WIDTHS list in project-poly/poly/public/templatetags/image_resizing.py
var AVAILABLE_WIDTHS = [
    25,
    50,
    60,
    100,
    154,
    200,
    205,
    300,
    365,
    400,
    800,
    1000,
    1200,
    1400,
    1600
];

/**
 * Appends a suffix to the filename part of a url path.
 *
 * @param {string} path
 * @param {string} suffix
 *
 * @example
 * // returns "http://www.google.com/something/index-suffix.html"
 * appendToUrlPath("http://www.google.com/something/index.html", "-suffix")
 */
var appendToUrlPath = function(path, suffix) {
    var pathParts = path.split("/");
    var file = pathParts.pop().split(".");
    var pathStart = pathParts.join("/");
    if (file.length <= 1) {
        return pathStart + "/" + file.join() + suffix;
    }
    var extension = file.pop();
    var withSuffix = file.join(".") + suffix + "." + extension;
    return pathStart + "/" + withSuffix;
};

/**
 * Get closest available target width for resizing (rounding up).
 *
 * @param {number} targetWidth
 *
 * @returns {number} Closest number to target width in the data source
 */
var resizeWidth = function(targetWidth) {
    var closest = _.find(AVAILABLE_WIDTHS, function(width) {
        return width >= targetWidth;
    });
    return closest || _.last(AVAILABLE_WIDTHS);
};

/**
 * Get the URL for an image resized to the given (or closest available) target width.
 *
 * @param {object} data
 * @param {string} photoKey
 * @param {number} targetWidth
 *
 * @returns {string}
 *
 * @example
 * // returns "http://www.google.com/photo-width-800.jpg"
 * resize(content, "photo", 800)
 */
var resize = function(data, photoKey, targetWidth) {
    // Default to original photo url if resize not ready
    var photo = data[photoKey];
    if (!data[photoKey + "_resize_ready"]) {
        return photo;
    }
    var width = targetWidth ? "-width-" + resizeWidth(targetWidth) : "";
    var urlParts = utils.parseUrl(photo);
    urlParts.pathname = appendToUrlPath(urlParts.pathname, width);
    return urlParts.getUrl();
};

exports.resize = resize;



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Lib1ThemeBuild/Platforms/1804Build/~/poly-js-utils/src/image-resizing.js
// module id = 198
// module chunks = 8